import PropTypes from 'prop-types';
import Image from 'next/image';
import PaymentIcon from '@material-ui/icons/Payment';
import { useTranslation } from 'react-i18next';
import useGetVehicle from '../hooks/useGetVehicle';
import CustomButton from './CustomButton';

const getIcon = (type) => {
  switch (type) {
    case 'mercadolibre':
      return <Image src="/mercadolibre-icon.png" alt="mercadolibre" width="25" height="20" />;
    default:
      return <PaymentIcon />;
  }
};

const getButtonType = (separateUrl) => {
  if (separateUrl.includes('mercadolibre.com')) return 'mercadolibre';

  return 'primary';
};

const SeparateButton = ({ className }) => {
  const { t } = useTranslation('details');
  const { vehicle } = useGetVehicle();
  const type = getButtonType(vehicle.separateUrl || '');

  if (!vehicle.separateUrl) return null;

  return (
    <div>
      <CustomButton
        id="separateButton"
        className={className}
        variant="contained"
        size="large"
        href={vehicle.separateUrl}
        color={type}
        target="_blank"
        startIcon={getIcon(type)}
      >
        {t('Separate')}
      </CustomButton>
    </div>
  );
};

SeparateButton.propTypes = {
  className: PropTypes.string,
};

SeparateButton.defaultProps = {
  className: '',
};

export default SeparateButton;
